import { Divider, Stack } from '@mui/material';
import { Treatments } from './Treatments';
import { Languages } from './Languages';
import { SpecialServices } from './SpecialServices';
import { useIsDesktop } from 'Hooks';
import { Accessible } from './Accessible';
import { MoreContactDetails } from './MoreContactDetails';
import { ITherapySuppliersResult } from 'API/Suppliers/suppliers';
import { supplierResourceFilterMapper } from 'Utils/suppliersResources';
import { useContext } from 'react';
import { SuppliersContext } from 'Context/SuppliersContext';

interface IDetails {
  data: ITherapySuppliersResult;
}

export const Details = ({ data }: IDetails) => {
  const { resources } = useContext(SuppliersContext);
  const isDesktop = useIsDesktop();

  const treatmentMethods: string[] = supplierResourceFilterMapper(
    resources.GISHA,
    data.treatmentMethods
  );

  const languages: string[] = supplierResourceFilterMapper(
    resources.LNGCD,
    data.languages
  );

  const homePhoneNumber: string | null =
    data.homePhonePrefix && data.homePhoneNumber
      ? `${data.homePhonePrefix}-${data.homePhoneNumber}`
      : null;

  return (
    <>
      {isDesktop && (
        <Divider
          orientation='horizontal'
          sx={{ mb: '24px', borderColor: 'primary.shade_100' }}
          aria-hidden={true}
        />
      )}
      {!isDesktop && data.hasAccessibilityForHandicapped && <Accessible />}
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        gap={isDesktop ? undefined : '20px'}
        sx={{
          mb: isDesktop ? undefined : '20px',
        }}
      >
        {treatmentMethods.length > 0 && (
          <Treatments treatmentMethods={treatmentMethods} />
        )}
        {languages.length > 0 && <Languages languagesList={languages} />}
      </Stack>
      {isDesktop && (treatmentMethods.length > 0 || languages.length > 0) && (
        <Divider
          orientation='horizontal'
          sx={{ m: '24px 0', borderColor: 'primary.shade_100' }}
          aria-hidden={true}
        />
      )}
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        gap={isDesktop ? undefined : '20px'}
      >
        {data.hasHomeVisit && <SpecialServices homeVisit={data.hasHomeVisit} />}
        {!isDesktop && (data.email || homePhoneNumber) && (
          <MoreContactDetails
            email={data.email}
            homePhoneNumber={homePhoneNumber}
          />
        )}
      </Stack>
    </>
  );
};
